var _path, _path2, _path3, _line, _path4, _path5, _path6, _rect, _path7, _path8, _line2, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _circle, _circle2, _rect2, _rect3, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _ellipse, _path16, _line3, _line4, _line5, _path17, _path18, _path19, _line6, _line7, _g, _path20, _path21, _path22, _path23, _path24, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg404(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1109,
    height: 558,
    viewBox: "0 0 1109 558",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M646 270L679.5 226.5L613.5 232.5L643.5 181L582.5 185L613.5 143L559 146.5L580.5 104.5L538 114L553 74L515.5 78L524.5 64.5",
    stroke: "#264C73",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M251 196L256.5 172.5L281 181L285.5 156L315 164V138L345 148L343.5 122L378.5 131V99.5L414.5 115L410.5 79.5L447.5 96L446.5 60.5L486.5 77L482 51.5",
    stroke: "#264C73",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M495.013 44.1971C493.116 41.1662 493.714 37.2048 496.421 34.8686L506.317 26.3261C509.376 23.6865 514.002 24.0576 516.6 27.151L713.208 261.23L659.071 306.368L495.013 44.1971Z",
    stroke: "#0B2642",
    strokeWidth: 7.24567
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 795.682,
    y1: 179.462,
    x2: 794.623,
    y2: 256.05,
    stroke: "#013556",
    strokeWidth: 7.24567
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M815.029 107.416C813.709 103.872 810.324 101.521 806.542 101.521H732.094C727.887 101.521 724.234 104.418 723.275 108.514L690.207 249.805C688.877 255.487 693.19 260.926 699.026 260.926H845.59V189.449L815.029 107.416Z",
    stroke: "#F8CF4E",
    strokeWidth: 10.8685
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M244.803 215.641C244.803 215.641 227.896 214.45 227.896 230.149C227.896 245.847 248.426 247.039 253.256 238.586",
    stroke: "#013556",
    strokeWidth: 4.83045,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M952.464 161.299H941.595C935.593 161.299 930.727 166.165 930.727 172.167V204.773",
    stroke: "#013556",
    strokeWidth: 10.8685,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: -2.5,
    width: 619,
    height: 109,
    rx: 54.5,
    transform: "matrix(-1 0 0 1 1109 335)",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeDasharray: "10 10"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M956.377 209.737C956.377 199.733 948.267 191.623 938.263 191.623H854.623V255.377H938.263C948.267 255.377 956.377 247.267 956.377 237.263V209.737Z",
    fill: "#F8CF4E",
    stroke: "#013556",
    strokeWidth: 7.24567
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1032.05 324.327C1030.18 294.001 1005 269.984 974.201 269.984H622.786C591.989 269.984 566.802 294.001 564.932 324.327H1032.05Z",
    fill: "#013556",
    stroke: "#F8CF4E",
    strokeWidth: 7.24567
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 709.733,
    y1: 177.6,
    x2: 840.156,
    y2: 177.6,
    stroke: "#F8CF4E",
    strokeWidth: 10.8685
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M716.183 169.5L730.81 109.5H806.036L801.786 169.5H716.183Z",
    fill: "#F28A41",
    stroke: "#013556",
    strokeWidth: 5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M244.803 195.716L244.803 215.641",
    stroke: "#013556",
    strokeWidth: 4.83045
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M151.157 275.541L234.482 242.935",
    stroke: "black",
    strokeWidth: 3.62284,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M242.388 244.624L372.81 335.195",
    stroke: "black",
    strokeWidth: 3.62284,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M94.068 298.423C99.7644 277.163 121.616 264.547 142.876 270.243L391.332 336.817C412.592 342.514 425.208 364.366 419.511 385.625L394.195 480.108C388.498 501.368 366.646 513.984 345.387 508.287L156.938 457.793L96.9303 441.714C75.671 436.017 63.0548 414.165 68.7512 392.906L94.068 298.423Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 7.24567
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M103.309 358.511L165.221 321.11L182.012 325.609L168.514 375.983L186.365 380.766L182.419 395.492L164.569 390.709L159.828 408.4L143.037 403.901L147.778 386.209L99.2576 373.209L103.309 358.511ZM151.723 371.484L159.529 342.351L123.438 363.905L151.723 371.484ZM201.745 375.066C203.533 368.391 206.144 362.676 209.576 357.918C213.008 353.16 217.07 349.442 221.762 346.763C226.463 344.049 231.723 342.43 237.54 341.907C243.357 341.384 249.55 342.003 256.118 343.763C262.686 345.523 268.359 348.083 273.135 351.445C277.912 354.807 281.657 358.838 284.372 363.539C287.095 368.205 288.754 373.457 289.348 379.293C289.941 385.129 289.344 391.384 287.555 398.058C285.767 404.733 283.157 410.448 279.725 415.206C276.292 419.964 272.23 423.682 267.539 426.361C262.847 429.04 257.592 430.641 251.775 431.164C245.957 431.687 239.765 431.068 233.196 429.308C226.628 427.548 220.956 424.988 216.179 421.626C211.403 418.265 207.653 414.251 204.929 409.585C202.205 404.919 200.546 399.667 199.953 393.831C199.359 387.995 199.957 381.74 201.745 375.066ZM218.55 379.512C217.339 384.032 216.87 388.183 217.144 391.965C217.452 395.757 218.42 399.139 220.046 402.111C221.681 405.047 223.94 407.563 226.823 409.66C229.714 411.722 233.173 413.292 237.199 414.371C241.224 415.45 245.005 415.819 248.54 415.48C252.085 415.105 255.299 414.055 258.184 412.33C261.078 410.569 263.589 408.119 265.717 404.981C267.88 401.851 269.567 398.026 270.778 393.506C271.98 389.021 272.422 384.901 272.104 381.144C271.83 377.362 270.88 373.985 269.254 371.013C267.628 368.042 265.369 365.525 262.478 363.464C259.595 361.367 256.141 359.779 252.116 358.7C248.09 357.621 244.305 357.27 240.76 357.644C237.225 357.984 234.01 359.034 231.117 360.794C228.223 362.555 225.694 365 223.531 368.129C221.412 371.233 219.752 375.027 218.55 379.512ZM302.156 411.792L364.068 374.391L380.859 378.89L367.361 429.264L385.212 434.047L381.266 448.772L363.416 443.989L358.675 461.681L341.884 457.182L346.624 439.49L298.104 426.489L302.156 411.792ZM350.57 424.765L358.376 395.632L322.284 417.186L350.57 424.765Z",
    fill: "#F86841"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M251.542 197.684C248.026 199.486 243.714 198.139 241.849 194.655L239.636 190.521C237.802 187.095 238.997 182.833 242.345 180.86L504.004 26.6348L525.544 57.2367L251.542 197.684Z",
    stroke: "#0B2642",
    strokeWidth: 7.24567
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 506.855,
    cy: 45.3675,
    r: 25.3599,
    fill: "white",
    stroke: "#013556",
    strokeWidth: 7.24567
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 507.5,
    cy: 45.5,
    r: 10.8772,
    fill: "#F28A41",
    stroke: "#013556",
    strokeWidth: 7.24567
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -3.62284,
    y: 3.62284,
    width: 597.768,
    height: 86.9481,
    rx: 43.474,
    transform: "matrix(-1 0 0 1 1092.77 340)",
    fill: "#013556",
    stroke: "#0B2642",
    strokeWidth: 7.24567
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -1.81142,
    y: 1.81142,
    width: 550.671,
    height: 54.3425,
    rx: 27.1713,
    transform: "matrix(-1 0 0 1 1071.03 358.115)",
    fill: "#0B2642",
    stroke: "white",
    strokeWidth: 3.62284
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.737,
    cy: 21.737,
    r: 21.737,
    transform: "matrix(-1 0 0 1 1065.79 365.361)",
    fill: "#264C73"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.737,
    cy: 21.737,
    r: 21.737,
    transform: "matrix(-1 0 0 1 1004.2 365.361)",
    fill: "#264C73"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.737,
    cy: 21.737,
    r: 21.737,
    transform: "matrix(-1 0 0 1 942.609 365.361)",
    fill: "#264C73"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.737,
    cy: 21.737,
    r: 21.737,
    transform: "matrix(-1 0 0 1 881.021 365.361)",
    fill: "#264C73"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.737,
    cy: 21.737,
    r: 21.737,
    transform: "matrix(-1 0 0 1 819.433 365.361)",
    fill: "#264C73"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.737,
    cy: 21.737,
    r: 21.737,
    transform: "matrix(-1 0 0 1 757.845 365.361)",
    fill: "#264C73"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.737,
    cy: 21.737,
    r: 21.737,
    transform: "matrix(-1 0 0 1 696.256 365.361)",
    fill: "#264C73"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.737,
    cy: 21.737,
    r: 21.737,
    transform: "matrix(-1 0 0 1 634.668 365.361)",
    fill: "#264C73"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.737,
    cy: 21.737,
    r: 21.737,
    transform: "matrix(-1 0 0 1 573.08 365.361)",
    fill: "#264C73"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 244.5,
    cy: 203,
    rx: 5.5,
    ry: 5,
    fill: "#013556"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M835.5 172L810.432 107.402C810.102 106.551 808.898 106.551 808.568 107.402L783.5 172H835.5Z",
    fill: "#0E4C74"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 881,
    y1: 212,
    x2: 928,
    y2: 212,
    stroke: "black",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 881,
    y1: 224,
    x2: 928,
    y2: 224,
    stroke: "black",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 881,
    y1: 236,
    x2: 928,
    y2: 236,
    stroke: "black",
    strokeWidth: 2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M708 183H792V255.5H692.5L708 183Z",
    fill: "#013556"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M709.5 212.5L701.258 245.469C700.622 248.013 702.564 250.47 705.185 250.439L742.5 250",
    stroke: "#013556",
    strokeWidth: 10.8685
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M777.5 183H799V255.5H744L777.5 183Z",
    fill: "#0E4C74"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 807.646,
    y1: 223.646,
    x2: 829.646,
    y2: 201.646,
    stroke: "black"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 809.646,
    y1: 235.646,
    x2: 831.646,
    y2: 213.646,
    stroke: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_758_467)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 806,
    cy: 452.5,
    rx: 280,
    ry: 3.5,
    fill: "#E6E6E6"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M986.533 137.046C981.321 132.277 978 125.068 978 117C978 102.641 988.521 91 1001.5 91C1013.56 91 1023.5 101.054 1024.85 114.001L1024.92 114L1025 114C1033.84 114 1041 121.835 1041 131.5C1041 141.165 1033.84 149 1025 149C1021.66 149 1018.56 147.88 1015.99 145.966C1016 146.143 1016 146.321 1016 146.5C1016 156.165 1008.84 164 1000 164C991.163 164 984 156.165 984 146.5C984 143.017 984.93 139.772 986.533 137.046Z",
    fill: "#D9D9D9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1070.19 95.4433C1075.31 94.0356 1079 90.1156 1079 85.5C1079 79.701 1073.18 75 1066 75C1058.82 75 1053 79.701 1053 85.5C1053 87.4041 1053.63 89.1898 1054.72 90.7296C1051.88 92.6078 1050 95.8346 1050 99.5C1050 105.299 1054.7 110 1060.5 110C1066.3 110 1071 105.299 1071 99.5C1071 98.0619 1070.71 96.6914 1070.19 95.4433Z",
    fill: "#D9D9D9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M66 245L83 262",
    stroke: "#FF0000",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M91 225L99.4701 247.5",
    stroke: "#FF0000",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M118.198 218.229L118.272 242.271",
    stroke: "#FF0000",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_758_467)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 219,
    cy: 550.5,
    rx: 215,
    ry: 3.5,
    fill: "#E6E6E6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_758_467",
    x: 522,
    y: 445,
    width: 568,
    height: 15,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_758_467"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_758_467",
    x: 0,
    y: 543,
    width: 438,
    height: 15,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_758_467"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.b48333e76b0e66e12a209a02327c0211.svg";
export { ForwardRef as ReactComponent };